import * as actionTypes from '../../action/discount/Discount'

const initialState = {
    error: false,
    errormessage: '',
    coupon:{}
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_DISCOUNT_FETCH:
            return {
                ...state,
                isCouponFetching: true
            };
        case actionTypes.GET_DISCOUNT_SUCCESS :
            return {
                ...state,
                isCouponFetching: false,
                error: false,
                coupon: action.payload
            };
        
        case actionTypes.GET_DISCOUNT_FAILURE :
            return {
                ...state,
                isCouponFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_DISCOUNT_MESSAGE:
            return {
                ...state,
                isCouponFetching: false,
                error: false,
                errormessage: action.payload
            };
        case actionTypes.DONE:
            return {
                ...state,
                isCouponFetching: false,
                coupon: state.discount
            }
        
        default:
            return state;
    }
}

export default reducer;